"use strict";

var _regeneratorRuntime = require("/app/front/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/app/front/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _classCallCheck = require("/app/front/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/app/front/node_modules/@babel/runtime/helpers/createClass.js");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Rpc_1 = __importDefault(require("../../Actions/Rpc"));

var RpcError_1 = __importDefault(require("../../Errors/RpcError"));

var Asset_1 = __importDefault(require("./Asset"));

var Cache_1 = __importDefault(require("./Cache"));

var Collection_1 = __importDefault(require("./Collection"));

var Offer_1 = __importDefault(require("./Offer"));

var Queue_1 = __importDefault(require("./Queue"));

var Schema_1 = __importDefault(require("./Schema"));

var Template_1 = __importDefault(require("./Template"));

var RpcApi = /*#__PURE__*/function () {
  function RpcApi(endpoint, contract) {
    var _this = this;

    var args = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
      rateLimit: 4
    };

    _classCallCheck(this, RpcApi);

    this.endpoint = endpoint;
    this.contract = contract;

    if (args.fetch) {
      this.fetchBuiltin = args.fetch;
    } else {
      this.fetchBuiltin = global.fetch;
    }

    this.queue = new Queue_1.default(this, args.rateLimit);
    this.cache = new Cache_1.default();
    this.action = new Rpc_1.default(this);
    this._config = new Promise( /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(resolve, reject) {
        var resp;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _this.getTableRows({
                  code: _this.contract,
                  scope: _this.contract,
                  table: 'config'
                });

              case 3:
                resp = _context.sent;

                if (!(resp.rows.length !== 1)) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt("return", reject('invalid config'));

              case 6:
                return _context.abrupt("return", resolve(resp.rows[0]));

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](0);
                reject(_context.t0);

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 9]]);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }());
  }

  _createClass(RpcApi, [{
    key: "config",
    value: function () {
      var _config = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this._config;

              case 2:
                return _context2.abrupt("return", _context2.sent);

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function config() {
        return _config.apply(this, arguments);
      }

      return config;
    }()
  }, {
    key: "getAsset",
    value: function () {
      var _getAsset = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(owner, id) {
        var cache,
            data,
            _args3 = arguments;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                cache = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : true;

                if (!cache) {
                  this.cache.deleteAsset(id);
                }

                _context3.next = 4;
                return this.queue.fetchAsset(owner, id, cache);

              case 4:
                data = _context3.sent;
                return _context3.abrupt("return", new Asset_1.default(this, owner, id, data, undefined, undefined, undefined, cache));

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getAsset(_x3, _x4) {
        return _getAsset.apply(this, arguments);
      }

      return getAsset;
    }()
  }, {
    key: "getTemplate",
    value: function () {
      var _getTemplate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(collectionName, templateID) {
        var cache,
            data,
            _args4 = arguments;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                cache = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : true;

                if (!cache) {
                  this.cache.deleteTemplate(collectionName, templateID);
                }

                _context4.next = 4;
                return this.queue.fetchTemplate(collectionName, templateID, cache);

              case 4:
                data = _context4.sent;
                return _context4.abrupt("return", new Template_1.default(this, collectionName, templateID, data, undefined, cache));

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getTemplate(_x5, _x6) {
        return _getTemplate.apply(this, arguments);
      }

      return getTemplate;
    }()
  }, {
    key: "getCollection",
    value: function () {
      var _getCollection = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(collectionName) {
        var cache,
            data,
            _args5 = arguments;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                cache = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : true;

                if (!cache) {
                  this.cache.deleteCollection(collectionName);
                }

                _context5.next = 4;
                return this.queue.fetchCollection(collectionName, cache);

              case 4:
                data = _context5.sent;
                return _context5.abrupt("return", new Collection_1.default(this, collectionName, data, cache));

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getCollection(_x7) {
        return _getCollection.apply(this, arguments);
      }

      return getCollection;
    }()
  }, {
    key: "getCollectionTemplates",
    value: function () {
      var _getCollectionTemplates = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(collectionName) {
        var _this2 = this;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.queue.fetchCollectionTemplates(collectionName);

              case 2:
                return _context6.abrupt("return", _context6.sent.map(function (templateRow) {
                  return new Template_1.default(_this2, collectionName, String(templateRow.template_id), templateRow, undefined);
                }));

              case 3:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function getCollectionTemplates(_x8) {
        return _getCollectionTemplates.apply(this, arguments);
      }

      return getCollectionTemplates;
    }()
  }, {
    key: "getCollectionsSchemas",
    value: function () {
      var _getCollectionsSchemas = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(collectionName) {
        var _this3 = this;

        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.queue.fetchCollectionSchemas(collectionName);

              case 2:
                return _context7.abrupt("return", _context7.sent.map(function (schemaRow) {
                  return new Schema_1.default(_this3, collectionName, schemaRow.schema_name, undefined);
                }));

              case 3:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function getCollectionsSchemas(_x9) {
        return _getCollectionsSchemas.apply(this, arguments);
      }

      return getCollectionsSchemas;
    }()
  }, {
    key: "getSchema",
    value: function () {
      var _getSchema = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(collectionName, schemaName) {
        var cache,
            data,
            _args8 = arguments;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                cache = _args8.length > 2 && _args8[2] !== undefined ? _args8[2] : true;

                if (!cache) {
                  this.cache.deleteSchema(collectionName, schemaName);
                }

                _context8.next = 4;
                return this.queue.fetchSchema(collectionName, schemaName, cache);

              case 4:
                data = _context8.sent;
                return _context8.abrupt("return", new Schema_1.default(this, collectionName, schemaName, data, cache));

              case 6:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function getSchema(_x10, _x11) {
        return _getSchema.apply(this, arguments);
      }

      return getSchema;
    }()
  }, {
    key: "getOffer",
    value: function () {
      var _getOffer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(offerID) {
        var cache,
            data,
            _args9 = arguments;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                cache = _args9.length > 1 && _args9[1] !== undefined ? _args9[1] : true;

                if (!cache) {
                  this.cache.deleteOffer(offerID);
                }

                _context9.next = 4;
                return this.queue.fetchOffer(offerID, cache);

              case 4:
                data = _context9.sent;
                return _context9.abrupt("return", new Offer_1.default(this, offerID, data, undefined, undefined, cache));

              case 6:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function getOffer(_x12) {
        return _getOffer.apply(this, arguments);
      }

      return getOffer;
    }()
  }, {
    key: "getAccountOffers",
    value: function () {
      var _getAccountOffers = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(account) {
        var _this4 = this;

        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return this.queue.fetchAccountOffers(account);

              case 2:
                return _context10.abrupt("return", _context10.sent.map(function (offerRow) {
                  return new Offer_1.default(_this4, offerRow.offer_id, offerRow, undefined, undefined);
                }));

              case 3:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function getAccountOffers(_x13) {
        return _getAccountOffers.apply(this, arguments);
      }

      return getAccountOffers;
    }()
  }, {
    key: "getAccountAssets",
    value: function () {
      var _getAccountAssets = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(account) {
        var _this5 = this;

        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return this.queue.fetchAccountAssets(account);

              case 2:
                return _context11.abrupt("return", _context11.sent.map(function (assetRow) {
                  return new Asset_1.default(_this5, account, assetRow.asset_id, assetRow, undefined, undefined, undefined);
                }));

              case 3:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function getAccountAssets(_x14) {
        return _getAccountAssets.apply(this, arguments);
      }

      return getAccountAssets;
    }()
  }, {
    key: "getCollectionInventory",
    value: function () {
      var _getCollectionInventory = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(collectionName, account) {
        var _this6 = this;

        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return this.queue.preloadCollection(collectionName, true);

              case 2:
                _context12.next = 4;
                return this.queue.fetchAccountAssets(account);

              case 4:
                return _context12.abrupt("return", _context12.sent.filter(function (assetRow) {
                  return assetRow.collection_name === collectionName;
                }).map(function (assetRow) {
                  return new Asset_1.default(_this6, account, assetRow.asset_id, assetRow, undefined, undefined, undefined);
                }));

              case 5:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function getCollectionInventory(_x15, _x16) {
        return _getCollectionInventory.apply(this, arguments);
      }

      return getCollectionInventory;
    }()
  }, {
    key: "preloadCollection",
    value: function () {
      var _preloadCollection = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(collectionName) {
        var cache,
            _args13 = arguments;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                cache = _args13.length > 1 && _args13[1] !== undefined ? _args13[1] : true;
                _context13.next = 3;
                return this.queue.preloadCollection(collectionName, cache);

              case 3:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function preloadCollection(_x17) {
        return _preloadCollection.apply(this, arguments);
      }

      return preloadCollection;
    }()
  }, {
    key: "getTableRows",
    value: function () {
      var _getTableRows = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(_ref2) {
        var code, scope, table, _ref2$table_key, table_key, _ref2$lower_bound, lower_bound, _ref2$upper_bound, upper_bound, _ref2$index_position, index_position, _ref2$key_type, key_type;

        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                code = _ref2.code, scope = _ref2.scope, table = _ref2.table, _ref2$table_key = _ref2.table_key, table_key = _ref2$table_key === void 0 ? '' : _ref2$table_key, _ref2$lower_bound = _ref2.lower_bound, lower_bound = _ref2$lower_bound === void 0 ? '' : _ref2$lower_bound, _ref2$upper_bound = _ref2.upper_bound, upper_bound = _ref2$upper_bound === void 0 ? '' : _ref2$upper_bound, _ref2$index_position = _ref2.index_position, index_position = _ref2$index_position === void 0 ? 1 : _ref2$index_position, _ref2$key_type = _ref2.key_type, key_type = _ref2$key_type === void 0 ? '' : _ref2$key_type;
                _context14.next = 3;
                return this.fetchRpc('/v1/chain/get_table_rows', {
                  code: code,
                  scope: scope,
                  table: table,
                  table_key: table_key,
                  lower_bound: lower_bound,
                  upper_bound: upper_bound,
                  index_position: index_position,
                  key_type: key_type,
                  limit: 101,
                  reverse: false,
                  show_payer: false,
                  json: true
                });

              case 3:
                return _context14.abrupt("return", _context14.sent);

              case 4:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function getTableRows(_x18) {
        return _getTableRows.apply(this, arguments);
      }

      return getTableRows;
    }()
  }, {
    key: "fetchRpc",
    value: function () {
      var _fetchRpc = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(path, body) {
        var response, json, f;
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.prev = 0;
                f = this.fetchBuiltin;
                _context15.next = 4;
                return f(this.endpoint + path, {
                  body: JSON.stringify(body),
                  method: 'POST'
                });

              case 4:
                response = _context15.sent;
                _context15.next = 7;
                return response.json();

              case 7:
                json = _context15.sent;
                _context15.next = 14;
                break;

              case 10:
                _context15.prev = 10;
                _context15.t0 = _context15["catch"](0);
                _context15.t0.isFetchError = true;
                throw _context15.t0;

              case 14:
                if (!(json.processed && json.processed.except || !response.ok)) {
                  _context15.next = 16;
                  break;
                }

                throw new RpcError_1.default(json);

              case 16:
                return _context15.abrupt("return", json);

              case 17:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this, [[0, 10]]);
      }));

      function fetchRpc(_x19, _x20) {
        return _fetchRpc.apply(this, arguments);
      }

      return fetchRpc;
    }()
  }]);

  return RpcApi;
}();

exports.default = RpcApi;